import { styled } from '@uhg-abyss/web/tools/styled';
import { Divider } from '@uhg-abyss/web/ui/Divider';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Popover } from '@uhg-abyss/web/ui/Popover';
import { Text } from '@uhg-abyss/web/ui/Text';

export const letterBadgeStyles = {
  'abyss-badge-root': {
    width: '44px',
    height: '44px',
    borderRadius: '999px',
    marginBottom: '$md',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0px',
    gap: '$md',
    '@media (max-width: 464px)': {
      width: '32px',
      height: '32px',
    },
  },
  'abyss-badge-content': {
    fontWeight: 'bold',
    lineHeight: '24px',
    fontSize: '14px',
    color: '#$core.color.neutral.80',
    '@media (max-width: 464px)': {
      color: '$core.color.neutral.90',
    },
  },
};

export const SectionContainer = styled(Flex, {
  alignItems: 'start',
  borderWidth: '1px 0px',
  borderStyle: 'solid',
  borderColor: '$cardBorder',
  marginTop: '$sm',

  padding: '$lg calc((100% - 1200px) / 2)',
  '@media (max-width: 1248px)': {
    padding: '$lg $md',
  },
  '@media (max-width: 744px)': {
    padding: '$md',
  },
});

export const SearchContainer = styled('div', {
  width: '100%',
});

export const radioGroupStyles = {
  'abyss-radio-group-label': {
    color: '$core.color.neutral.90',
    fontWeight: 700,
    fontSize: '25.63px',
    lineHeight: '32px',
    marginBottom: '24px',
  },
  'abyss-radio-group-container': {
    flexDirection: 'column',
    padding: 0,
    gap: 0,
  },
  '&.abyss-radio-root': {
    marginBottom: '$lg',
    padding: '10px 0',
  },
};

export const containerStyles = {
  'abyss-flex-root': {
    padding: '$md $md',
    '@media (min-width: 745px)': {
      padding: '$md 84px',
    },
    '@media (max-width: 744px)': {
      paddingLeft: '16px',
    },
  },
};

export const StyledResultsContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '$xs',
  '@media (max-width: 464px)': {
    justifyContent: 'space-between',
    width: '100%',
  },
});

export const ResultsContainerStyle = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '$xs',
  '@media (max-width: 464px)': {
    gap: '0px',
  },
});

export const styledIcon = {
  'abyss-icon-symbol': {
    marginRight: '4px',
    '@media (max-width: 464px)': {
      width: '16px',
      height: '16px',
      marginRight: '0px',
    },
  },
};

export const textContentStyles = {
  'abyss-text-root': {
    marginRight: '$md',
    '@media (max-width: 744px)': {
      fontSize: '16px',
    },
    '@media (max-width: 464px)': {
      color: '#4B4D4F',
    },
  },
};

export const layoutGroupStyles = {
  'abyss-layout-group': {
    width: '100%',
    '& > div': {
      width: '100%',
    },
  },
};

export const physicianLinkStyles = (removeTruncation: boolean) => ({
  display: 'flex',
  '&.abyss-link-root': {
    fontWeight: '600',
    fontSize: '$md',
    lineHeight: '20px',
    alignItems: 'center',
    textAlign: 'left',
    marginBottom: '12px',
    display: 'inline-block',
    minWidth: '230px',
    maxWidth: '335px',
    ...(removeTruncation
      ? {}
      : { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }),
    '@media (min-width: 745px)': {
      maxWidth: '380px',
      marginBottom: '$md',
    },
  },
  mark: {
    backgroundColor: 'transparent',
  },
  marginLeft: '2px',
});

export const physicianNameStyles = (removeTruncation: boolean) => ({
  ...(removeTruncation
    ? {
        display: '-webkit-box',
        '-webkit-line-clamp': '2',
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }
    : {}),
});

export const StyledPopover = styled(Popover, {
  '&.abyss-popover-root': {
    padding: '24px 24px 24px 16px',
    borderRadius: '12px',
    zIndex: '9 !important',
  },
  '&.abyss-popover-close-button': {
    marginTop: '12.5px',
    right: '$md',
  },
});

export const MobileText = styled(Text, {
  'abyss-text-root': {
    display: 'block',
    '@media (min-width: 745px)': {
      display: 'none',
    },
  },
});

export const DesktopSortText = styled(Text, {
  'abyss-text-root': {
    display: 'none',
    '@media (min-width: 745px)': {
      display: 'block',
    },
  },
});

export const swapIconStyles = {
  '&div': {
    marginLeft: 0,
  },
};

export const StyledDivider = styled(Divider, {
  '&.abyss-divider-root': {
    height: '1px !important',
    '@media (max-width: 464px)': {
      display: 'none',
    },
  },
});

export const ProviderSpeciality = styled('div', {
  fontWeight: 500,
  color: '#4B4D4F',
  sixe: '16px',
  lineHeight: '20px',
  textTransform: 'capitalize',
  textWrap: 'pretty',
});

export const ContentTextContainer = styled(Text, {
  '&.abyss-text-root': {
    color: '#323334',
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: '500',
    '@media (max-width: 464px)': {
      fontSize: '16px',
      lineHeight: '20px',
    },
  },
  '.abyss-link-root': {
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '24px',
    '@media (max-width: 464px)': {
      fontSize: '16px',
      lineHeight: '20px',
    },
  },
});

export const DirectoryTextContainer = styled(Text, {
  '&.abyss-text-root': {
    color: '#323334',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '20px',
    '@media (max-width: 464px)': {
      fontSize: '14.22px !important',
    },
  },
});
